<template>
  <div
    class="userDatatable global-shadow border p-30 bg-white radius-xl w-100 mb-30"
    :class="cardClass"
  >
    <slot />
  </div>
</template>

<script>
export default {
  name: 'ContentCard',
  props: {
    cardClass: {
      type: String,
      default: '',
    },
  },
}
</script>
